// Route: /study-plan/[id]/subsection/[subId] — LEGACY redirect → тема курса
// /courses/[courseId]/topics/[topicId].
//
// «Подсекция плана» стала «Темой курса» (обучающая система, docs/plans/
// LEARNING-SYSTEM-UI.md §4). Модель та же (тема == study_subsections), id не
// меняются: id → courseId, subId → topicId.
//
// Этот redirect держит живыми: `?from=subsection:<planId>:<subId>` (lib/
// back-from.ts — формат строки сознательно не переименован), deep-links из
// писем/уведомлений и back-ссылки со страниц карточек/тестов/аудио.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	demo: z
		.enum(["default", "loading", "empty", "error", "streaming", "generating"] as const)
		.optional(),
});

export const Route = createFileRoute("/study-plan/$id_/subsection/$subId")({
	validateSearch: tolerantSearch(searchSchema),
	// `search` намеренно не деструктурируется: переносить из него нечего,
	// см. комментарий ниже. `validateSearch` выше при этом обязателен — он
	// не даёт битому легаси-URL упасть ДО редиректа.
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/courses/$courseId/topics/$topicId",
			params: { courseId: params.id, topicId: params.subId },
			// Цель валидируется `courseWorkspaceSearchSchema`, а в ней `demo` нет —
			// переносить нечего. Пустой объект вместо каста: сегодня схемы просто
			// не пересекаются, и это должно быть видно, а не спрятано (2026-08-14).
			search: {},
			replace: true,
		});
	},
});
